import React, { useReducer, useCallback } from 'react'
import { Button, Box } from '@mui/material'
import ColorButton from '../Buttons/ColorButton'
import { lockedReducer } from '../Utils/reducers'
import { hasPermissions } from '../Utils/groups'

import Conhecimentos from './conhecimentos'
import PercentualFrete from './percentualFrete'
import BoletoConhecimento from './boletoConhecimento'

const frameMenu = () => ({
    'conhecimentos': { title: 'Conhecimentos', component: (<Conhecimentos />), permission: hasPermissions('administrador', 'grupo_administradores', 'admfilial') },
    'boletos_cte': { title: 'Boletos × Ct-e', component: (<BoletoConhecimento />), permission: hasPermissions('administrador', 'grupo_administradores', 'admfilial') },
    'percentual_frete': { title: 'Percentual Frete', component: (<PercentualFrete />), permission: hasPermissions('administrador', 'grupo_administradores', 'admfilial') }
})

const IndexConhecimentos = () => {
    const [state, setState] = useReducer(lockedReducer, {
        tab: 'conhecimentos' || 'notas' || 'contas_a_pagar' || 'percentual_frete'
    })

    const frame = useCallback(() => {
        return frameMenu()
    }, [])

    const frame_data = Object.entries(frame()).filter(([_, value]) => value.permission)

    return (
        <>
            <Box className='multitab-select-box'>
                {frame_data.map(([key, value]) => (
                    <ColorButton reverse={state.tab !== key} onClick={() => setState({ tab: key })}>
                        {value.title}
                    </ColorButton>
                ))}
            </Box>
            <Box className='multitab-mainframe'>
                {frame()[state.tab].component}
            </Box>
        </>
    )
}

export default IndexConhecimentos